var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',_vm._b({directives:[{name:"visible",rawName:"v-visible.once",value:(_vm.drawPage),expression:"drawPage",modifiers:{"once":true}}],staticClass:"pdf-page",class:{ focus:_vm.isPageFocused }},'canvas',_vm.canvasAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }